import template from './tutorial_component.html';
class TutorialComponentViewModel
{
    constructor(params) 
    {
        
        try {
            // Initialize basic observables first
            this.tutorial_mode = ko.observable(false);
            this.intro_started = ko.observable(false);
            this.current_intro_step = ko.observable(0);
            this.tutorial_steps = ko.observableArray([]);
            this.mock_data_created = ko.observable(false);
            
            // Check intro.js availability
            let intro_avail = typeof window.introJs !== 'undefined' || typeof introJs !== 'undefined';
            this.intro_available = ko.observable(intro_avail);
            
            // Store parameters safely
            this.parent_view_model = params ? params.parent_view_model : null;

            console.log('parent view model', this.parent_view_model);
            this.page_id = params ? params.page_id : 'generic';
            this.raw_tutorial_config = params ? params.tutorial_config : null;
            
            // Initialize with default config first
            this.config = this.get_default_config();
            
            // Set up configuration retrieval with better timing
            this.setup_configuration_retrieval();
            
        }
        catch (error)
        {
            this.create_safe_fallback();
        }
    }
    
    get_default_config()
    {
        return {
            pageTitle: 'Page Features',
            page_id: this.page_id || 'generic',
            autoStartWelcome: false,
            showFloatingButton: true,
            storagePrefix: this.page_id || 'tutorial',
            step_definitions: [],
            permissionCheckers: {},
            roleBadges: {},
            mockDataCreators: {},
            mockDataCleaners: {},
            additionalSelectors: []
        };
    }
    
    create_safe_fallback() 
    {
        this.tutorial_mode = ko.observable(false);
        this.intro_started = ko.observable(false);
        this.intro_available = ko.observable(false);
        this.current_intro_step = ko.observable(0);
        this.tutorial_steps = ko.observableArray([]);
        this.config = this.get_default_config();
    }
    
    setup_configuration_retrieval() 
    {
        // Multiple attempts with increasing delays to account for page loading
        let attempts = [0, 1000, 2000, 3000, 5000];
        
        attempts.forEach((delay, index) => {
            setTimeout(() => {
                if (this.config.step_definitions.length === 0) {
                    this.attempt_config_retrieval(index);
                }
            }, delay);
        });
    }
    
    attempt_config_retrieval(attempt_number)
    {
        
        try {
            let actual_config = null;
            
            if (ko.isObservable(this.raw_tutorial_config)) 
                actual_config = this.raw_tutorial_config();
            else 
                actual_config = this.raw_tutorial_config;
            
            
            if (!actual_config) return false;
            
            
            let unwrapped_config = this.unwrap_configuration(actual_config);
            
            if (!unwrapped_config || !unwrapped_config.steps) return false;
            
            this.config = this.initialize_config(unwrapped_config);
            
            return true;
            
        }
        catch (error)
        {
            console.error(` Error in config retrieval attempt ${attempt_number + 1}:`, error);
            return false;
        }
    }
    
    unwrap_configuration(raw_config)
    {
        if (!raw_config || typeof raw_config !== 'object') return null;
        
        // Check if already properly formatted
        if (raw_config.steps && Array.isArray(raw_config.steps)) 
            return raw_config;
        
        // Check for wrapped config
        if (raw_config.performance_tutorial_config)
        {
            const wrapped = raw_config.performance_tutorial_config;
            if (this.is_valid_config(wrapped)) return wrapped;
        }
        
        //Add new tutorial step config pages to the wrapper keys
        // Check other wrapper keys
        let wrapperKeys = [
            'tutorial_config',
            'config',
            'performance_tutorial_config',
            'performance_dashboard_tutorial_config',
            'performance_management_setup_tutorial_config'
        ];
        
        for (const key of wrapperKeys)
        {
            if (raw_config[key] && this.is_valid_config(raw_config[key])) return raw_config[key];
            
        }
        
        return null;
    }
    
    is_valid_config(config)
    {
        return config && 
               typeof config === 'object' && 
               config.steps && 
               Array.isArray(config.steps) && 
               config.steps.length > 0;
    }
    
    initialize_config(actual_config)
    {
        if (!actual_config || !actual_config.steps) return this.get_default_config();
        
        return {
            pageTitle: actual_config.pageTitle || 'Tutorial',
            page_id: actual_config.page_id || 'generic',
            autoStartWelcome: actual_config.autoStartWelcome !== false,
            showFloatingButton: actual_config.showFloatingButton !== false,
            storagePrefix: actual_config.storagePrefix || this.page_id || 'tutorial',
            step_definitions: actual_config.steps || [],
            permissionCheckers: actual_config.permissionCheckers || {},
            roleBadges: actual_config.roleBadges || {},
            mockDataCreators: actual_config.mockDataCreators || {},
            mockDataCleaners: actual_config.mockDataCleaners || {},
            additionalSelectors: actual_config.additionalSelectors || [],
            ...actual_config
        };
    }
    
    create_mock_data() 
    {
        if (!this.parent_view_model || this.mock_data_created()) return;
        
        
        try 
        {
            // Execute all mock data creators from config
            let creators = this.config.mockDataCreators || {};
            
            Object.keys(creators).forEach(creatorKey => {
                const creator = creators[creatorKey];
                if (typeof creator === 'function')
                {
                    try {
                        creator.call(this.parent_view_model);
                    }
                    catch (error)
                    {
                        console.error(`Error in mock data creator ${creatorKey}:`, error);
                    }
                }
            });
            
            this.mock_data_created(true);
            
        }
        catch (error) {
            console.error('Error creating mock data:', error);
        }
    }

    cleanup_mock_data() 
    {
        if (!this.parent_view_model || !this.mock_data_created()) return;
        
        try 
        {
            let cleaners = this.config.mockDataCleaners || {};
            
            Object.keys(cleaners).forEach(cleanerKey => {
                let cleaner = cleaners[cleanerKey];
                if (typeof cleaner === 'function')
                {
                    try {
                        cleaner.call(this.parent_view_model);
                    }
                    catch (error) 
                    {
                        console.error(`Error in mock data cleaner ${cleanerKey}:`, error);
                    }
                }
            });
            
            this.mock_data_created(false);
            
        }
        catch (error)
        {
            console.error('Error cleaning up mock data:', error);
        }
    }
    
    enter_tutorial_mode() 
    {
        
        this.tutorial_mode(true);
        
        document.body.classList.add('tutorial-mode-active');
        
        this.create_mock_data();
        
        this.force_element_visibility();
        
        setTimeout(() => {
            this.setup_tutorial_steps();
        }, 1000);
    }
    
    exit_tutorial_mode() 
    {
        
        if (window.introJs)
        {
            try {
                window.introJs().exit();
            }
            catch (e) 
            {
                console.log('No active tour to exit');
            }
        }
        
        this.cleanup_mock_data();
        
        document.body.classList.remove('tutorial-mode-active');
        
        // Clean up forced visibility
        document.querySelectorAll('.tutorial-forced-visible').forEach(el => {
            el.classList.remove('tutorial-forced-visible');
            el.style.removeProperty('display');
            el.style.removeProperty('visibility');
            el.style.removeProperty('opacity');
        });
        
        // Reset tutorial state
        this.tutorial_mode(false);
        this.intro_started(false);
        this.current_intro_step(0);
    }
    
    // Force element visibility for tutorial
    force_element_visibility() 
    {
        let configSelectors = this.config.additionalSelectors || [];
        let defaultSelectors = [
            '[style*="display: none"]',
            '[style*="visibility: hidden"]',
            '[data-bind*="visible:"]',
            '[data-visible-feature]'
        ];
        
        let all_selectors = [...new Set([...defaultSelectors, ...configSelectors])];
        
        all_selectors.forEach(selector => {
            document.querySelectorAll(selector).forEach(el => {
                let style = window.getComputedStyle(el);
                if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') 
                {
                    el.style.setProperty('display', 'block', 'important');
                    el.style.setProperty('visibility', 'visible', 'important');
                    el.style.setProperty('opacity', '1', 'important');
                    el.classList.add('tutorial-forced-visible');
                }
            });
        });
        
        // Special handling for knockout-bound elements
        setTimeout(() => {
            document.querySelectorAll('button, .ps-btn-primary, .ps-btn-danger, .ps-btn-warning').forEach(el => {
                if (window.getComputedStyle(el).display === 'none')
                {
                    el.style.setProperty('display', 'inline-block', 'important');
                    el.classList.add('tutorial-forced-visible');
                }
            });
        }, 500);
    }

     switch_tab_for_step(step_index) 
     {
        if (!this.config.step_to_tab_mapping) return;
        
        let tabname = this.config.step_to_tab_mapping[step_index];
        if (!tabname) return;

        let tab_element = document.querySelector(`li[data-tabname="${tabname}"]`);
        if (!tab_element) return;

        if (this.parent_view_model?.switch_tabs) 
        {
            try {
                this.parent_view_model.switch_tabs(this.parent_view_model, {
                    currentTarget: tab_element
                });
            } catch (error) {
                $(tab_element).click();
            }
        } else {
            $(tab_element).click();
        }
    }
    
    setup_tutorial_steps() 
    {
        if (this.config.step_definitions.length === 0) 
        {
            this.setup_basic_steps();
            return;
        }
        
        let steps = [];
        let successful_steps = 0;
        
        // Add welcome step
        steps.push(this.create_welcome_step());
        
        // Process each step definition
        this.config.step_definitions.forEach((step_def, index) => {
            
            try {
                let step = this.create_step_from_definition(step_def, index);
                if (step) 
                {
                    steps.push(step);
                    successful_steps++;
                }
                else if (!step_def.optional)
                {
                    // For required steps, create them anyway with a warning
                    let fallback_step = {
                        intro: `
                            <h4>${step_def.title}</h4>
                            <p>${step_def.description}</p>
                            <p style="color: #ff9800;"><strong>⚠️ This feature is not currently visible on the page, but would normally be here.</strong></p>
                            <p><em>In tutorial mode, some elements may not be available.</em></p>
                        `,
                        position: 'center'
                    };
                    steps.push(fallback_step);
                }
            }
            catch (error) {
                console.error(`Error creating step "${step_def.title}":`, error);
            }
        });
        
        // Add summary step
        steps.push(this.create_summary_step(successful_steps));
        
        this.tutorial_steps(steps);
        
    }
    
    create_step_from_definition(step_def, index) {
        let element = null;
        let selectors = Array.isArray(step_def.element) ? step_def.element : [step_def.element];
        
        // Try each selector
        for (let i = 0; i < selectors.length; i++)
        {
            let selector = selectors[i];
            
            try {
                element = document.querySelector(selector);
                if (element)
                {
                    console.log(` Found element with: "${selector}"`);
                    break;
                }
            }
            catch (error) {
                console.log(`Invalid selector: "${selector}"`);
            }
        }
        
        // If no element found and step is optional, skip it
        if (!element && step_def.optional) return null;
        
        // Create the step
        let permissions = this.evaluate_permissions(step_def.permissions || []);
        let permission_badges = permissions.map(p => 
            this.get_role_requirement_badge(p.type, p.has_access)
        ).join('');
        
        let step = {
            intro: `
                <h4>${step_def.title}</h4>
                <p>${step_def.description}</p>
                
                ${permission_badges ? `<div style="margin: 10px 0;"><p><strong>Access Options:</strong></p>${permission_badges}</div>` : ''}
                
                ${step_def.requirements ? `<p><strong>Access:</strong> ${step_def.requirements}</p>` : ''}
                ${step_def.purpose ? `<p><strong>Purpose:</strong> ${step_def.purpose}</p>` : ''}
                ${step_def.additionalInfo ? `<div>${step_def.additionalInfo}</div>` : ''}
                
                ${!element ? '<p style="color: #ff9800;"><strong>⚠️ Element not currently visible - this would appear when conditions are met.</strong></p>' : ''}
            `,
            position: step_def.position || 'auto'
        };
        
        // Add element if found
        if (element)
        {
            step.element = element;
            this.ensure_element_visible(element);
        }
        
        return step;
    }
    
    ensure_element_visible(element) 
    {
        if (element) 
        {
            let computed_style = window.getComputedStyle(element);
            if (computed_style.display === 'none' || 
                computed_style.visibility === 'hidden' || 
                computed_style.opacity === '0') {
                
                element.style.setProperty('display', 'block', 'important');
                element.style.setProperty('visibility', 'visible', 'important');
                element.style.setProperty('opacity', '1', 'important');
                element.classList.add('tutorial-forced-visible');
            }
        }
    }
    
    create_welcome_step() 
    {
        return {
            intro: `
                <h4>${this.config.pageTitle} Tutorial</h4>
                <p>Welcome to the ${this.config.pageTitle} feature tutorial!</p>
                <p>This guide walks you through all available features on this page ; including some that may not usually be visible, depending on your access level.</p>
                
                <p><strong>Tutorial Details:</strong></p>
                <ul>
                    <li><strong>Steps to cover:</strong> ${this.config.step_definitions.length}</li>
                    <li><strong>Mock data:</strong>  Sample data is provided for demonstration</li>
                    <li><strong>Hidden elements:</strong> All features are temporarily visible for learning</li>
                </ul>
                
                <p><small><strong>Note:</strong> Mock data and enhanced visibility are active only during tutorial mode.</small></p>
            `
        };
    }
    
    create_summary_step(successful_steps) 
    {
        return {
            intro: `
                <h4>Tutorial Complete!</h4>
                <p>You've completed the ${this.config.pageTitle} tutorial!</p>
                
                <p><strong> Summary:</strong></p>
                <ul>
                    <li><strong>Features covered:</strong> ${successful_steps} out of ${this.config.step_definitions.length}</li>
                    <li><strong>Mock data:</strong> Will be removed when you exit</li>
                    <li><strong>Normal visibility:</strong> Will be restored based on your permissions</li>
                </ul>
                
                <div style="margin: 15px 0;">
                    ${this.generate_permission_badges()}
                </div>
                
                <p style="margin-top: 20px; padding: 15px; background: #e3f2fd; border-radius: 8px;">
                    <strong>Next Steps:</strong> The tutorial will now exit and restore normal page functionality. 
                    Only features you have permission to use will remain visible.
                </p>
            `
        };
    }
    
    setup_basic_steps() 
    {
        let steps = [{
            intro: `
                <h4>🔍 Basic Page Tour</h4>
                <p>The configured tutorial steps couldn't be loaded.</p>
                <p>Here's a basic tour of available elements.</p>
            `
        }];
        
        let basic_selectors = [
            { selector: '.ps-table', title: 'Data Table' },
            { selector: '.ps-btn-primary', title: 'Primary Button' },
            { selector: 'select', title: 'Dropdown' }
        ];
        
        basic_selectors.forEach(({ selector, title }) => {
            let element = document.querySelector(selector);
            if (element) {
                steps.push({
                    element: element,
                    intro: `<h4>${title}</h4><p>Found element: <code>${selector}</code></p>`,
                    position: 'auto'
                });
            }
        });
        
        this.tutorial_steps(steps);
    }
    
    evaluate_permissions(permission_list) 
    {
        return permission_list.map(permission => {
            let has_access = false;
            let checker = this.config.permissionCheckers[permission.type];
            
            if (checker && typeof checker === 'function' && this.parent_view_model) 
            {
                try {
                    has_access = Boolean(checker.call(this.parent_view_model));
                }
                 catch (error) {
                    console.warn(`Permission checker error for ${permission.type}:`, error);
                }
            }
            
            return {
                type: permission.type,
                has_access: has_access,
                label: permission.label || permission.type
            };
        });
    }
    
    generate_permission_badges()
     {
        if (!this.config.permissionCheckers || !this.parent_view_model) return '<p><em>No permission information available</em></p>';
        
        let badges = [];
        Object.keys(this.config.permissionCheckers).forEach(permission_type => {
            let checker = this.config.permissionCheckers[permission_type];
            let has_access = false;
            
            try {
                has_access = checker.call(this.parent_view_model);
            } catch (error) {
                console.warn(`Permission check failed for ${permission_type}:`, error);
            }
            
            badges.push(this.get_role_requirement_badge(permission_type, has_access));
        });
        
        return badges.join('');
    }
    
    get_role_requirement_badge(role_type, has_access) {
        let badge_config = this.config.roleBadges?.[role_type] || {
            text: role_type.charAt(0).toUpperCase() + role_type.slice(1)
        };
        
        let color = has_access ? '#4caf50' : '#f44336';
        let status = has_access ? '✓' : '✗';
        
        return `
            <span style="
                display: inline-block;
                background: ${color};
                color: white;
                padding: 3px 8px;
                border-radius: 12px;
                font-size: 11px;
                font-weight: 600;
                margin: 2px;
            ">
                ${badge_config.text} ${status}
            </span>
        `;
    }
    
    // Toggle tutorial mode
    toggle_tutorial_mode() 
    {
        let new_mode = !this.tutorial_mode();
        this.tutorial_mode(new_mode);
        
        if (new_mode) {
            //this.enter_tutorial_mode();
        } else {
            this.exit_tutorial_mode();
        }
    }
    
    // Start tour - only called when "Start Tour" button is clicked
    start_tour() 
    {
        this.setup_tutorial_steps();
        this.create_mock_data();

        if (!this.intro_available()) 
        {
           Grape.alerts.alert({Type: 'warning', title: 'Warning', message: 'Tutorial library not available. Please refresh the page and try again.'});
            return;
        }
        
        if (this.tutorial_steps().length === 0) 
        {
            this.setup_tutorial_steps();
            setTimeout(() => this.start_tour(), 1000);
            return;
        }
        
        try {
            // Hide any existing overlays
            document.querySelectorAll('.introjs-overlay, .introjs-backdrop').forEach(el => el.remove());
            
            const intro = introJs();
            intro.setOptions({
                steps: this.tutorial_steps(),
                showProgress: true,
                showBullets: false,
                exitOnOverlayClick: false,
                exitOnEsc: true,
                nextLabel: 'Next →',
                prevLabel: '← Previous',
                skipLabel: 'Exit Tutorial',
                doneLabel: 'Complete Tutorial',
                overlayOpacity: 0.7,
                tooltipClass: 'introjs-custom-tooltip'
            });

             // Tab switching logic
            intro.onbeforechange((target_element) => {
                const currentStep = intro._currentStep || 0;
                this.switch_tab_for_step(currentStep);
                
                // Wait for tab to render
                return new Promise((resolve) => {
                    setTimeout(resolve, 300);
                });
            });
            
            // Add event handlers
            intro.onchange((target_element) => {
                this.current_intro_step(intro._currentStep || 0);
                
                if (target_element) 
                {
                    this.ensure_element_visible(target_element);
                    target_element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }

                const currentStep = intro._currentStep || 0;
                const totalSteps = this.tutorial_steps().length;
                const isLastStep = currentStep === totalSteps - 1;

                 setTimeout(() => {
                    const nextButton = document.querySelector('.introjs-nextbutton');
                    const prevButton = document.querySelector('.introjs-prevbutton');
                    
                    if (isLastStep) {
                        if (nextButton) nextButton.style.display = 'none';
                        if (prevButton) prevButton.style.display = 'none';
                    } else {
                        if (nextButton) nextButton.style.display = '';
                        if (prevButton) prevButton.style.display = '';
                    }
                }, 50);
            });
            
            intro.onexit(() => {
                this.intro_started(false);
            });
            
            intro.oncomplete(() => {
                this.intro_started(false);
                // Don't auto-exit tutorial mode - let user decide
            });
            
            // Start the tour
            this.intro_started(true);
            this.switch_tab_for_step(0);
            
            setTimeout(() => {
                intro.start();
            }, 400);
            
        } catch (error) {
         Grap.alerts.alert({type: 'error', title: 'Error', message: 'Error starting tutorial. Please refresh the page and try again.'});
            this.intro_started(false);
        }
    }
    
   
    // Dispose method
    dispose() 
    {
        
        if (this.tutorial_mode()) 
            this.exit_tutorial_mode();
        
        // Clean up any remaining tutorial artifacts
        document.body.classList.remove('tutorial-mode-active');
        document.querySelectorAll('.tutorial-forced-visible').forEach(el => {
            el.classList.remove('tutorial-forced-visible');
        });
    }
}

export default {
    name: 'tutorial-component',
    viewModel: TutorialComponentViewModel,
    template: template
};